import tetoriRoze2026 from "./tetoriRoze2026";

/**
 * Survey-specific themes for the survey filler (`viewer/Preview`).
 *
 * A theme only ever applies to the surveys it is assigned to, by survey id, through
 * `REACT_APP_SURVEY_THEMES` - a comma separated list of `<surveyId>=<themeKey>` pairs, e.g.
 *
 *    REACT_APP_SURVEY_THEMES=3f2c…e91a=tetori-roze-2026
 *
 * Survey ids differ per environment, so each .env file carries its own list. Any survey that is
 * not listed renders exactly as before.
 */
const THEMES = {
   [tetoriRoze2026.key]: tetoriRoze2026
};

export const parseSurveyThemeMap = (raw) => {
   if (!raw) {
      return {};
   }

   return raw.split(",").reduce((map, pair) => {
      const [surveyId, themeKey] = pair.split("=").map((part) => part?.trim());

      if (surveyId && themeKey) {
         map[surveyId.toLowerCase()] = themeKey;
      }
      return map;
   }, {});
};

const SURVEY_THEME_MAP = parseSurveyThemeMap(process.env.REACT_APP_SURVEY_THEMES);

export const getSurveyTheme = (surveyId, themeMap = SURVEY_THEME_MAP) => {
   if (!surveyId) {
      return null;
   }

   return THEMES[themeMap[String(surveyId).toLowerCase()]] ?? null;
};
